import React, { useEffect, useState } from "react";
import Breadcrumb from "./breadcrumb";
import { image_url } from "../config";
import { Link } from 'react-router-dom';
import './../css/space.css'

const Spaces = (props) => {


    let imgURL = image_url

    const [pageBreadcrumb, setBreadcrumb] = useState();
    const [bannerImage, setBannerImage] = useState();
    const [secondSectionData, setSecondSection] = useState();

    useEffect(() => {
        setBreadcrumb(props?.data[0][0].page_name);
        props?.data?.map((res) => {
            if (res[0]?.section_name == 'banner') {
                setBannerImage(imgURL + 'banner_image/' + res[0]?.image);
            } else if (res[0]?.section_name == 'second_section') {
                setSecondSection(res);
            }
        });
    })

    const breadcrumbObject = {
        img: bannerImage,
        breadcumbs: pageBreadcrumb
    }

    return (
        <>
            <Breadcrumb data={breadcrumbObject} />
            <section className="space_listing_section">
                {/* <h2 className="main_heading">{sectionCardHeading}</h2> */}
                <div className="row m-0 nav_link_cards">
                    {secondSectionData?.map((res, index) =>
                        <div className="project_card">
                            {/* <a style={{ textDecoration: "none", cursor: "pointer" }} href={res?.url}> */}
                            <Link to={'/'+res?.url}>
                                <div className="card_box">
                                    <div className="card_image">
                                        <img src={imgURL + 'section_third_list_image/' + res?.image} />
                                    </div>
                                    <div className="card_content">
                                        <h2 className="card_heading m-0 heading_family">{res?.heading}</h2>
                                        {index % 3 == 0 ?
                                            <div className="design_section" style={{ background: "#ffca05" }}></div>
                                            : ''}
                                        {index % 3 == 1 ?
                                            <div className="design_section" style={{ background: "#f26f21" }}></div>
                                            : ''}
                                        {index % 3 == 2 ?
                                            <div className="design_section" style={{ background: "#e21f26" }}></div>
                                            : ''}
                                    </div>
                                </div>
                            </Link>
                            {/* </a> */}
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}

export default Spaces;